var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 37,
    viewBox: "0 0 27 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.91895 2.08924V2.77306H5.26272V2.08924H7.91895ZM5.47578 0V5.00318H4.61328V0H5.47578ZM8.58215 0V5.00318H7.72308V0H8.58215ZM11.5648 0V5.00318H10.7092V0H11.5648ZM13.1352 0V0.687251H9.15257V0H13.1352ZM14.1454 0H14.9151L16.3619 3.85891L17.805 0H18.5747L16.6642 5.00318H16.0525L14.1454 0ZM13.795 0H14.5269L14.654 3.34003V5.00318H13.795V0ZM18.1934 0H18.9286V5.00318H18.0663V3.34003L18.1934 0ZM23.0866 4.31936V5.00318H20.5747V4.31936H23.0866ZM20.8153 0V5.00318H19.9527V0H20.8153Z",
    fill: "url(#paint0_linear_1171_32)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.1975 33.285L0 6.46924L26.2438 6.52312L23.9201 33.285L13.221 36.3784L2.1975 33.285Z",
    fill: "#E34F26"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1948 33.739V9.10791L24.0442 9.14364L22.1095 31.1809L13.1948 33.739Z",
    fill: "#EF652A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9533 15.1657L21.2582 11.894H4.69092L5.60626 21.9246H17.0402L16.5917 26.2026L12.93 27.1911L9.21444 26.1128L9.01703 23.5602H5.73195L6.18076 28.7732L12.9297 30.6606L19.7326 28.7732L20.6479 18.599H8.63992L8.2989 15.1657H20.9533Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1171_32",
    x1: 4.10471,
    y1: 3.39044,
    x2: 24.0441,
    y2: 3.39044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E34F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF652A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/html.644b54946cfbba40bf4cada5eaa100ef.svg";
export { ForwardRef as ReactComponent };